import rootReducer from './reducers'
import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension';
import { localStorageMdl } from './middleware/localStorage/'
import { crmMdl } from './middleware/crm'

const initialState = {}

const middleware = [thunk,
    ...localStorageMdl,
    ...crmMdl
]

const store = createStore(
    rootReducer,
    initialState,
    composeWithDevTools(
        applyMiddleware(...middleware)
    )
)

export default store
